<template>
  <base-card
    :icons="icons"
    :heading="heading"
    :scrollable="displayArt ? false : true"
    @icon-clicked="iconClicked"
  >
    <img :src="placeholderImage" v-if="displayArt" alt="No tasks left" />
    <to-do-item
      v-for="(toDo, index) in sortedToDos"
      :key="index"
      :toDo="toDo"
    />
  </base-card>
</template>
<script>
import BaseCard from "../UI/BaseCard.vue";
import ToDoItem from "../UI/ListItems/ToDo/ToDoItem.vue";
export default {
  data() {
    return {
      placeholderImage: require("../UI/Illustrations/BeachDJNoTasksLeft.png"),
    };
  },
  methods: {
    iconClicked() {
      this.$emit("icon-clicked");
    },
  },
  computed: {
    displayArt() {
      return this.toDos.length === 0;
    },
    sortedToDos() {
      if (this.toDos) {
        let array = [...this.toDos];
        return array.sort((a, b) => {
          return Number(b.completed) - Number(a.completed);
        });
      } else {
        return [];
      }
    },
  },
  components: {
    BaseCard,
    ToDoItem,
  },
  emits: ["icon-clicked"],
  props: ["toDos", "icons", "heading"],
};
</script>

<style scoped>
img {
  width: 80%;
  height: 80%;
  object-fit: contain;
  margin: auto;
}
</style>
